// extracted by css-extract-rspack-plugin
export default {"menu":"menu-vY1N0K","menuList":"menuList-pgX8nh","menuItem":"menuItem-zgv3UT"};